
import WDPane from '../pane/wd-pane';

export default class WDPaneCards extends WDPane
{

	#options = {
		navigation_mode: 'tabs',
		tab_position: 'right',
		collapsible: true,
		breakpoint: 'md'
	};

	constructor(opts)
	{
		super(opts).classList.add('wd-pane-cards');

		if (opts) Object.assign(this.#options, opts);

		if (this.#options.collapsible) 
		{
			//this.navbar[this.#options.tab_position].collapseBreakpoint = this.#options.breakpoint;
			this.navbar.collapsible = true;
			this.navbar.toggleIcon = 'fa-solid ellipsis-v';
		}
	};

	get items() { return this.body.children; };
	get itemArray() { return [...this.items]; };

	reset()
	{
		//empty the body and the menubar
		this.body.replaceChildren();

		const menuFunc = this.#options.tab_position; //(left, center, right)
		this.navbar[menuFunc].empty();
	};

	addCard(card, labelName, icon)
	{
		this.body.append(card);
		card.hide();

		const shortcode = 'wd-card-' + labelName.toLowerCase().replace(' ', '');
		card.classList.add(shortcode);

		card.dataset.shortcode = shortcode;
		card.dataset.label = labelName;
		if (icon) card.dataset.icon = icon;
		
		//build our storage object
		this.addCardNav(card);

		//if this is the first card, show it
		if (this.items.length == 1) this.showCard(shortcode);
	};

	showCard(shortcode)
	{
		this.updateCardNav(shortcode);

		this.itemArray.forEach(card =>
		{
			if (card.dataset.shortcode == shortcode) 
			{
				card.trigger('card:show');
				card.show('flex');
				card.trigger('card:shown');

				if (this.#options.collapsible == true)
				{
					this.navbar.toggleButton.label = card.dataset.label;
					if (card.dataset.icon) this.navbar.toggleIcon = card.dataset.icon;
				}
			}
			else 
			{
				card.trigger('card:hide');
				card.hide();
				card.trigger('card:hidden');
			}

		});

	};

	addCardNav(card)
	{
		const menuFunc = this.#options.tab_position;
		const menu = this.navbar[menuFunc];
		menu.classList.add('wd-pane-cards-nav');

		const btn = menu.add({ label: card.dataset.label });
		btn.dataset.shortcode = card.dataset.shortcode;
		btn.on('click', (evt) => this.showCard(card.dataset.shortcode));

		if (card.dataset.icon) btn.icon = card.dataset.icon;
	};

	updateCardNav(shortcode)
	{
		const menuFunc = this.#options.tab_position;
		const menu = this.navbar[menuFunc];

		const selBtn = menu.querySelector('.is-active');
		const scBtn = menu.querySelector(`[data-shortcode="${shortcode}"]`);

		if (selBtn != null) selBtn.classList.remove('is-active');
		scBtn.classList.add('is-active');
	};

};

customElements.define('wd-pane-cards', WDPaneCards);
